import { useParams } from 'react-router-dom';

export function useValidOrgId(): number | undefined {
  const { orgId } = useParams<{ orgId: string }>();
  const orgIdNum = orgId ? Number(orgId) : undefined;
  return orgIdNum !== undefined && Number.isFinite(orgIdNum)
    ? orgIdNum
    : undefined;
}
